import { localePrefixes } from '../../i18n/i18n-navigation';
import { DEFAULT_LOCALE } from '../../i18n/locales';

export const getRelativePathWithoutLocale = (path: string, locale: string) => {
  if (locale === DEFAULT_LOCALE) return path;

  const customPrefix = localePrefixes[locale as keyof typeof localePrefixes];
  const prefixToStrip = customPrefix ?? `/${locale}`;
  const stripped = path.replace(new RegExp(`^${prefixToStrip}(?=/|$)`, 'u'), '');

  return stripped || '/';
};
